document.addEventListener("DOMContentLoaded", () => {
    const nl_form = document.querySelector('form.newsletter-form');
    const list_id = nl_form.dataset.listId;
    const sub_source = nl_form.dataset.subSource;

    if(nl_form){
        const nl_message = document.getElementById('newsletter_form_message_container');
        nl_form.addEventListener('submit', (e) => {
            e.preventDefault();
            const emailInput = nl_form.querySelector('input[type="email"]');
            const email = emailInput.value;
            const notifyButton = nl_form.querySelector('button');
            const subscribe_check = nl_form.querySelector('#newsletter_opt_in').checked;

            nl_message.className = "newsletter-form__message";

            notifyButton.textContent = window.translations.t_buttonLabelSending;
            notifyButton.disabled = true;

            if (subscribe_check) {
                if (!email) {
                    console.error("Error: Email is undefined or empty.");
                    return;
                }

                const profile = JSON.stringify({
                    data: {
                        type: "subscription",
                        attributes: {
                            profile: {
                                data: {
                                    type: "profile",
                                    attributes: {
                                        "properties": {
                                            "subscription_source": sub_source
                                        },
                                        subscriptions: {
                                            email: {
                                                marketing: {
                                                    consent: "SUBSCRIBED"
                                                }
                                            }
                                        },
                                        email: email
                                    }
                                }
                            },
                            custom_source: sub_source
                        },
                        relationships: {
                            list: {
                                data: {
                                    type: "list",
                                    id: list_id
                                }
                            }
                        }
                    }
                });

                const options = {
                    method: 'POST',
                    headers: {
                    accept: 'application/vnd.api+json',
                    revision: '2025-01-15',
                    'content-type': 'application/vnd.api+json'
                    },
                    body: profile
                };

                fetch('https://a.klaviyo.com/client/subscriptions?company_id=SFsnHs', options)
                    .then(response => {
                        if (response.status === 202) {
                            nl_form.remove();
                            nl_message.classList.add('inSuccess');
                            nl_message.textContent = window.translations.t_success;
                        } else {
                            nl_message.classList.add('inError');
                            nl_message.textContent = "Error: " + (data.error_message || "Unknown error");
                        }
                    })
                    .catch(error => {
                        nl_message.classList.add('inError');
                        nl_message.textContent = "Error: Unable to process your request. Please try again later.";
                    });

            } else {
                nl_message.classList.add('inError');
                nl_message.textContent = window.translations.t_terms_accept;
                notifyButton.textContent = window.translations.t_buttonLabel;
                notifyButton.disabled = false;
            }
        });
    }
});